import ModelUserist from "./userist/ModelUserist";

// Basic Models
export const UserM = new ModelUserist('User');
export const CardM = new ModelUserist('Card');

// Userist
export const SignUpM = new ModelUserist('SignUp');
export const SignInM = new ModelUserist('SignIn');
export const TokenSignInM = new ModelUserist('TokenSignIn');
export const FindPasswordM = new ModelUserist('FindPassword');
export const ChangePasswordM = new ModelUserist('ChangePassword');
export const CheckEmailM = new ModelUserist('CheckEmail');
export const CheckPhoneM = new ModelUserist('CheckPhone');


